module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', [_c('app-nav')], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": "/img/cartaz.jpg",
      "alt": "Cartaz"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50ba2a86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pub/Home.vue
// module id = 257
// module chunks = 1